module.exports = __webpack_public_path__ + "static/media/balance_2_산소발생기.c3af1efa.jpg";